import { createContext } from "react";
import { createContextualCan, useAbility } from "@casl/react";

export const AbilityContext = createContext();
export const ability = () => useAbility(AbilityContext);
export const Can = createContextualCan(AbilityContext.Consumer);
